export enum ATInternetCustomObjectField {
  'USER_ID' = 'userId',
}
